import React from 'react';
import SimpleCell from '@/components/table/SimpleCell';
import RequestIcon from './RequestIcon';

const RequestNameCell = ({ allowTransfer, request }) => (
  <SimpleCell className="td-request-name" content={request.name}>
    <RequestIcon allowTransfer={allowTransfer} request={request} />
  </SimpleCell>
);

export default RequestNameCell;
